import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store';
import { SessionEndReasons } from './sessionBoundary.constants';

const selectSessionBoundary = (state: RootState) => state.sessionBoundary;
const selectSessionStatus = createSelector(
  selectSessionBoundary,
  (state) => state.sessionStatus
);
const selectSessionStartReason = createSelector(
  selectSessionBoundary,
  (state) => state.sessionStartReason
);
const selectSessionEndReason = createSelector(
  selectSessionBoundary,
  (state) => state.sessionEndReason
);

const selectSessionId = createSelector(
  selectSessionBoundary,
  (state) => state.sessionId
);

const selectFinalOrderSubmitted = createSelector(
  selectSessionBoundary,
  (state) => state.finalOrderSubmitted
);

const selectOrderMessageData = createSelector(
  selectSessionBoundary,
  (state) => state.orderMessageData
);

const selectIsPostCarExitTimerActive = createSelector(
  selectSessionBoundary,
  (state) => state.isPostCarExitTimerActivated
);

const selectIsSessionTimeoutDialogOpen = createSelector(
  selectSessionBoundary,
  (state) => state.isSessionTimeoutDialogOpen
);

// Car exit ends the order: it either ends the session outright
// (sessionEndReason = car_exit) or, with a pending order, arms the post-car-exit
// timer. Shared by the express-timer latchers so they stop re-arming once the
// car has left rather than fighting the car-exit reset (infinite render loop).
const selectIsCarExited = createSelector(
  selectSessionEndReason,
  selectIsPostCarExitTimerActive,
  (sessionEndReason, isPostCarExitTimerActive) =>
    sessionEndReason === SessionEndReasons.carExit || isPostCarExitTimerActive
);

const selectOrderId = createSelector(
  selectSessionBoundary,
  (state) => state.orderMessageOrderId
);

const selectShowOrderSubmissionAlert = createSelector(
  selectSessionBoundary,
  (state) => state.showOrderSubmissionAlert
);

const selectEndedSessionId = createSelector(
  selectSessionBoundary,
  (state) => state.endedSessionId
);

export {
  selectFinalOrderSubmitted,
  selectIsCarExited,
  selectIsPostCarExitTimerActive,
  selectIsSessionTimeoutDialogOpen,
  selectOrderId,
  selectOrderMessageData,
  selectSessionEndReason,
  selectSessionId,
  selectSessionStartReason,
  selectSessionStatus,
  selectShowOrderSubmissionAlert,
  selectEndedSessionId,
};
